"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMark = exports.getMarkingList = exports.isStringIncludes = void 0;
const highLightSearcher_1 = require("./highLightSearcher");
// TODO : 대소문자 구분 잘못됨 ( 소문자 검색 -> 대문자 허용 만 되고 반대는 안됌)
const isStringIncludes = (list, targetStr) => {
    const includes = list.filter((elem) => {
        return targetStr.toUpperCase().includes(elem.toUpperCase());
    });
    const result = includes.length !== 0 ? true : false;
    return result;
};
exports.isStringIncludes = isStringIncludes;
const getMarkingList = ({ isIncludes, main_name, branch, targetStringList, // input 을 ' ' 로 split 한 배열
 }) => {
    // targetStringList 를 순회하며 계속 값을 담아줄 공간
    // 처음 브랜치와 메인네임을 합쳐 문자열을 담을 공간
    let newStr = "";
    let result = [];
    if (!isIncludes) {
        return result;
    }
    if (!targetStringList) {
        return result;
    }
    if (!newStr) {
        const branchedName = branch ? main_name + " " + branch : main_name;
        // 새 문자열을 생성해서 담아줌
        newStr = String(branchedName);
    }
    // ex : 검색어 - 스타벅스 dt, Js 가든
    // ex : 자동완성 - 스타벅스 DT 구의점, js가든 센터필드점
    const temp = (0, highLightSearcher_1.highLightSearcher)({
        searcherList: targetStringList,
        origin: newStr,
        test: true,
    });
    return (0, exports.setMark)({ combiner: temp.value, origin: temp.originMatcher });
};
exports.getMarkingList = getMarkingList;
const setMark = ({ combiner, origin }) => {
    const splitedCombiner = combiner.split("_");
    const filted = splitedCombiner.filter((elem) => elem !== "");
    const markList = filted.map((markElem, idx) => {
        for (const item of origin) {
            if (markElem.includes(item)) {
                return `+${markElem}`;
            }
        }
        return markElem;
    });
    const result = markList.filter((elem) => elem !== "");
    return result;
};
exports.setMark = setMark;
